import { COUNTRIES } from 'appconstants';
import getCountryAlpha2 from 'utils/getCountryAlpha2';

export default ({ refArray, countryId }) => {
  const businessInfo = refArray[0].current.getValues();
  const bankDetailsInfo = refArray[1].current.getValues();
  const businessRepresentativesInfo = refArray.slice(2).map(ref => {
    const info = ref.current.getValues();
    return {
      givenName: info.firstName,
      familyName: info.lastName,
      email: info.contactEmail,
      phone: `${info.countryCode}${info.phoneNumber}`,
      gid: info.gid,
      title: info.title,
      pan: info.panNumber,
      ssn: info.ssnNumber,
      address: {
        countryCode: getCountryAlpha2(countryId),
        city: info.city,
        postalCode: info.zipCode,
        state: info.state,
        street: info.legalAddress,
      },
      kycAddressProofUrl: info.bankStatementUrl,
      businessRepPanUrl: info.businessRepPanUrl,
      ownerShipPercentage: info.ownerShipPercentage ? info.ownerShipPercentage.replace('%', '') : null,
      governmentIdUrl: info.driverLicenseUrl || null,
      dateofbirth: info.dob,
      hasControl: info.control,
    };
  });

  let payload;

  switch (countryId) {
    case COUNTRIES.USA.id:
    case COUNTRIES.CANADA.id:
      payload = {
        usBusiness: {
          name: businessInfo.businessName,
          url: businessInfo.businessUrl,
          statementDescriptor: businessInfo.businessStatementDescriptor,
          categoryId: businessInfo.businessCategory,
          address: {
            countryCode: getCountryAlpha2(countryId),
            city: businessInfo.businessCity,
            postalCode: businessInfo.zipCode,
            state: businessInfo.businessState,
            street: businessInfo.streetAddress,
          },
          companyStartDate: businessInfo.companyStartDate,
          businessPhoneNumber: `${businessInfo.countryCode}${businessInfo.phoneNumber}`,
          type: businessInfo.businessType,
          ein: businessInfo.employerIdNumber,
          bankName: bankDetailsInfo.nameOfBank,
          bankAccountType: bankDetailsInfo.accountType,
          bankRoutingNumber: bankDetailsInfo.bankRoutingNumber,
          bankAccountNumber: (!bankDetailsInfo.accountNumber.includes('*') && bankDetailsInfo.accountNumber) || undefined,
          bankBeneficiaryName: bankDetailsInfo.accountHolderName,
          averageMonthlyVolume: Math.trunc(Number(bankDetailsInfo.averageMonthlyVolume) * 100),
          averageTicketAmount: Math.trunc(Number(bankDetailsInfo.averageTicketAmount) * 100),
          whenIsCardCharged: bankDetailsInfo.whenIsCardCharged,
          servicesDeliveredIn: bankDetailsInfo.servicesDeliveredIn,
          refundPolicy: bankDetailsInfo.refundPolicy,
          seasonalBusiness: bankDetailsInfo.seasonalBusiness,
          modeOfTransactionOnline: (bankDetailsInfo.modeOfTransactionPerson === 100 || bankDetailsInfo.modeOfTransactionPerson === '100')
            ? '0' : bankDetailsInfo.modeOfTransactionOnline
              ? (bankDetailsInfo.modeOfTransactionOnline).toString() : '',
          modeOfTransactionPerson: (bankDetailsInfo.modeOfTransactionOnline === 100 || bankDetailsInfo.modeOfTransactionOnline === '100')
            ? '0' : bankDetailsInfo.modeOfTransactionPerson
              ? (bankDetailsInfo.modeOfTransactionPerson).toString() : '',
          isEbt: (bankDetailsInfo.modeOfTransactionOnline === 100 || bankDetailsInfo.modeOfTransactionOnline === '100')
            ? false : bankDetailsInfo.EBTCheckBox
              ? bankDetailsInfo.EBTCheckBox : false,
          isTaxExemptOrganisation: businessInfo.isTaxExemptOrganisation || false,
          requestedServiceDate: (bankDetailsInfo.modeOfTransactionOnline === 100 || bankDetailsInfo.modeOfTransactionOnline === '100')
            ? '9999-12-31' : bankDetailsInfo.requestedServiceDate
              ? bankDetailsInfo.requestedServiceDate : '9999-12-31',
          isServiceDateFlexible: (bankDetailsInfo.modeOfTransactionOnline === 100 || bankDetailsInfo.modeOfTransactionOnline === '100')
            ? false : bankDetailsInfo.isServiceDateFlexible
              ? bankDetailsInfo.isServiceDateFlexible : false,
          voidCheckUrl: bankDetailsInfo.voidCheckUrl || null,
        },
        usBusinessReps: businessRepresentativesInfo,
      };
      break;
    case COUNTRIES.INDIA.id:
      // eslint-disable-next-line no-case-declarations
      const pin = {};
      businessInfo.cin = businessInfo.cin !== '' ? businessInfo.cin : '';
      if (businessInfo.isLLP) {
        pin.llpin = businessInfo.cin;
      } else {
        pin.cin = businessInfo.cin;
      }

      payload = {
        inBusiness: {
          name: businessInfo.businessName,
          url: businessInfo.businessUrl,
          statementDescriptor: businessInfo.businessStatementDescriptor,
          categoryId: businessInfo.businessCategory,
          address: {
            countryCode: getCountryAlpha2(countryId),
            city: businessInfo.businessCity,
            postalCode: businessInfo.zipCode,
            state: businessInfo.businessState,
            street: businessInfo.streetAddress,
          },
          businessPan: businessInfo.businessPan,
          type: businessInfo.businessType,
          tan: businessInfo.tan,
          gst: businessInfo.gst,
          kycCompanyPanUrl: businessInfo.panUrl,
          kycRegistrationProofUrl: businessInfo.registrationProofUrl,
          bankBeneficiaryName: bankDetailsInfo.accountHolderName,
          bankName: bankDetailsInfo.nameOfBank,
          bankIfscCode: bankDetailsInfo.ifscNumber,
          kycBankStatementUrl: bankDetailsInfo.bankStatementUrl || undefined,
          currentAddressProofUrl: businessInfo.currentAddressProofUrl,
          boardResolutionUrl: businessInfo.boardResolutionUrl,
          gstCertificateUrl: businessInfo.gstCertificateUrl,
          eightyGAndTwelveACertificate: businessInfo.eightyGAndTwelveACertificate || null,
          accountType: businessInfo.accountType,
          annualTurnOver: Number(businessInfo.annualTurnOver),
          annualCardVolume: Number(businessInfo.annualCardVolume),
          annualUpiVolume: Number(businessInfo.annualUpiVolume),
          kycStoreFront: businessInfo.frontUrl,
          kycStoreInside: businessInfo.insideUrl,
          bankAccountNumber: (!bankDetailsInfo.accountNumber.includes('*') && bankDetailsInfo.accountNumber) || bankDetailsInfo.bankAccountNumber,
          ...pin,
        },
        inBusinessReps: businessRepresentativesInfo,
      };
      break;
    default:
      break;
  }

  return payload;
};
